import React from "react";
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Programs from "./components/programs/Programs";
// import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Achievements from "./components/achivements/Achivements";
// import Poster from "./components/poster/Posters";
// import Resume from "./components/resume/Resume";
// import Testimonial from "./components/tesimonial/Testimonial";

function App() {
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <Navbar />
      <div className="max-w-screen-xl mx-auto">
        {/* <Poster /> */}
        <Banner />
        <Programs />
        <div style={{display: 'flex', justifyContent: 'center', marginTop: 30}}>
        <iframe width="800" height="500" src="https://www.youtube.com/embed/eDO229sa9gQ?si=LsZgESNzZAGfBFdI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        {/* <Projects /> */}
        <Achievements />
      {/* <Resume /> */}
        {/* <Testimonial /> */}
        <Contact />
        {/* <Footer /> */}
        <FooterBottom />
      </div>
    </div>
  );
}

export default App;
